import { createContext } from 'react';

const subAreaContext = createContext();

export default subAreaContext;